import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Swal from "sweetalert2";

import DialogTitle from "@mui/material/DialogTitle";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { API_URL } from "../../../../api";
export default function BankInfoDialog(props) {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [relatedBrandList, setRelatedBrandList] = useState([]);
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [categoryLists, setCategoryLists] = useState([]);
  const [subCategoryLists, setSubCategoryLists] = useState([]);

  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [relatedBrand, setRelatedBrand] = useState("");

  const [description, setDescription] = useState("");

  const [errors, setErrors] = useState({
    code: "",
    name: "",
    category: "",
    subCategory: "",
    relatedBrand: "",
  });

  console.log("errors", errors);

  const MedicineItemCreate = (e) => {
    e.preventDefault();
    let required = {};
    if (!code) {
      required.code = "Code is required";
    }
    if (!name) {
      required.name = "Name is required";
    }
    if (!category) {
      required.category = "Category is required";
    }
    if (!subCategory) {
      required.subCategory = "SubCategory is required";
    }
    if (!relatedBrand) {
      required.relatedBrand = "Related Brand is required";
    }
    if (Object.keys(required).length > 0) {
      setErrors(required);
      return;
    }

    setErrors({
      code: "",
      name: "",
      category: "",
      subCategory: "",
      relatedBrand: "",
    });

    const data = {
      name: name,
      code: code,
      description: description,
      relatedCategory: category,
      relatedSubCategory: subCategory,
      relatedBrand: relatedBrand,
    };
    // alert(JSON.stringify(data))
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api.post("medicine-list", data, config).then(function (response) {
      Swal.fire({
        title: "Successful!",
        text: "Medicine List Created Successfully!",
        icon: "success",
        // showCancelButton: true,

        cancelButtonText: "Close",
      });

      window.location.reload();
      // props.setMedicineLists((prev) => [response?.data?.data, ...prev]);
    });

    // .catch(function (err) {
    //   Swal.fire({
    //     title: 'Something Wrong!',
    //     text: 'Error',
    //     icon: 'warning',
    //     // showCancelButton: true,

    //     cancelButtonText: 'Close'
    //   })
    // })
    props.setOpen(false);
  };

  useEffect(() => {
    const getCategory = async () => {
      try {
        const res = await api.get("categories");

        setCategoryLists(res.data.data);
      } catch (err) {}
    };
    const getSubCategory = async () => {
      try {
        const res = await api.get("sub-categories");

        setSubCategoryLists(res.data.data);
      } catch (err) {}
    };

    const getBrandLists = async () => {
      try {
        const res = await api.get("brands");
        setRelatedBrandList(res.data.data);
      } catch (err) {
        alert(err.message);
      }
    };
    getCategory();
    getSubCategory();

    getBrandLists();
  }, []);

  return (
    <div>
      <Dialog open={props.open} onClose={props.close}>
        <DialogTitle>
          <div className="modal-header bg-info">
            <h4 className="modal-title">Create New Item</h4>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={props.close}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </DialogTitle>
        <DialogContent>
          <form action="" onSubmit={(e) => MedicineItemCreate(e)}>
            {/* @csrf */}
            <div class="modal-body">
              <div class="form-group">
                <label for="code">
                  Code <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control border border-info"
                  name="code"
                  onChange={(e) => setCode(e.target.value)}
                />
                {errors?.code && (
                  <div className="text-danger">{errors?.code}</div>
                )}
              </div>
              <div class="form-group">
                <label for="name">
                  Name <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control border border-info"
                  name="name"
                  placeholder="eg. mg mg"
                  onChange={(e) => setName(e.target.value)}
                />
                {errors?.name && (
                  <div className="text-danger">{errors?.name}</div>
                )}
              </div>
              <div class="form-group">
                <label for="name">
                  Category <span class="text-danger">*</span>
                </label>
                <select
                  class="custom-select border-info"
                  name="account_type_id"
                  id="cat"
                  onChange={(e) => setCategory(e.target.value)}
                >
                  <option hidden>Choose Category</option>
                  {categoryLists.map((option) => (
                    <option value={option._id}>{option.name}</option>
                  ))}
                </select>
                {errors?.category && (
                  <div className="text-danger">{errors?.category}</div>
                )}
              </div>
              <div class="form-group">
                <label for="name">
                  Sub Category <span class="text-danger">*</span>
                </label>
                <select
                  class="custom-select border-info"
                  id="subCat"
                  name="account_type_id"
                  onChange={(e) => setSubCategory(e.target.value)}
                >
                  <option hidden>Choose Sub Category</option>
                  {subCategoryLists.map((option) => (
                    <option value={option._id}>{option.name}</option>
                  ))}
                </select>
                {errors?.subCategory && (
                  <div className="text-danger">{errors?.subCategory}</div>
                )}
              </div>

              <div class="form-group">
                <label for="name">
                  Choose Brand <span class="text-danger">*</span>
                </label>
                <select
                  name="currency"
                  id=""
                  className="form-control mt-1"
                  onchange="convert(this.value)"
                  onChange={(e) => setRelatedBrand(e.target.value)}
                >
                  <option hidden>Choose Brand</option>

                  {relatedBrandList.map((option) => (
                    <option value={option._id}>{option.name}</option>
                  ))}
                </select>
                {errors?.relatedBrand && (
                  <div className="text-danger">{errors?.relatedBrand}</div>
                )}
              </div>
              <div class="form-group">
                <label for="name">Description</label>
                <textarea
                  className="form-control"
                  id="description"
                  onChange={(e) => setDescription(e.target.value)}
                ></textarea>
              </div>
            </div>
            <div class="modal-footer">
              <Button
                class="btn btn-secondary"
                data-dismiss="modal"
                onClick={props.close}
                type="button"
              >
                Close
              </Button>
              <Button class="btn btn-primary" type="submit">
                Save
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
}
// phyo
//maymyat
